import React from "react";
import { Typewriter } from "react-simple-typewriter";
const Test = () => {
  // const handleType = (count: number) => {
  //     // access word count number
  //     console.log(count)
  // }

  const handleDone = () => {
    console.log(`Done after 5 loops!`);
  };

  return (
    <div className="App " style={{ marginLeft: "0px", marginTop: "250px" }}>
      <h1 style={{ fontSize: "50px", color: "white" }}>NAZMUL HAQUE SHAKIL</h1>
      <h1
        style={{ paddingTop: "1rem", margin: "auto 0", fontWeight: "normal" }}
      >
        <span style={{ color: "red", fontWeight: "bold", color: "white" }}>
          {/* Style will be inherited from the parent element */}

          <Typewriter
            words={[
              "MERS Stact Developer",
              "Wev Designer",
              "Programmer",
              "Wev Developer!",
            ]}
            loop={100000}
            cursor
            cursorStyle="_"
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1000}
            onLoopDone={handleDone}
            // onType={handleType}
          />
        </span>
      </h1>
    </div>
  );
};

export default Test;
